export default function saveToLocalStorage(name: string, value: string) {
    localStorage.setItem(name, value)
}